export function createPdfUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.onload = (e) => {
      if (e.target?.result) {
        resolve(URL.createObjectURL(new Blob([e.target.result as ArrayBuffer], {
          type: 'application/pdf',
        })));
      } else {
        reject(new Error('Failed to read file'));
      }
    };

    fileReader.onerror = reject;
    fileReader.readAsArrayBuffer(file);
  });
}
